import { setupListeners } from '@reduxjs/toolkit/query';
import { persistStore } from 'redux-persist';
import { makeStore } from '@bbkAdminRedux/make-store';

const store = makeStore();

const persistor = persistStore(store);

setupListeners(store.dispatch);

window.bbkStore = store;

export { store, persistor };
